import { observeServiceAvailability, serviceRetryAt, STOCK_PHOTOS_BUSY, STOCK_PHOTOS_BUSY_MESSAGE } from 'utils/serviceAvailability';

export const isStockPhotoBusy = (error) => error?.code === STOCK_PHOTOS_BUSY || Number(error?.status) === 429;
export const getSuggestedImageErrorMessage = (error, fallback = 'Suggested images are temporarily unavailable.') => (
  isStockPhotoBusy(error) ? STOCK_PHOTOS_BUSY_MESSAGE : fallback
);
export function suggestedImageError(error, fallback) {
  const busy = isStockPhotoBusy(error);
  if (busy) observeServiceAvailability({ ...error, code: STOCK_PHOTOS_BUSY });
  return { code: busy ? STOCK_PHOTOS_BUSY : 'IMAGE_UNAVAILABLE',
    message: getSuggestedImageErrorMessage(error, fallback),
    retryAt: busy ? serviceRetryAt(STOCK_PHOTOS_BUSY) : 0 };
}
